import React from 'react'
import {
    Link,
  } from "react-router-dom";

export const Reports = (props) => {
    return (
        <div>
            <div className="container">

                <h3 className="mt-4 mb-3" style={{fontFamily: 'effraReg'}}>BronzeTag Reports
            
                </h3>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" style={{fontFamily: 'effraReg'}}>Reports</li>
                </ol>

                <div className="row">
                <div class="col-lg-12">
                    <p style={{fontFamily: 'effraReg'}}>BronzeTag POS offers a rich collection of reports including sales reports, purchase reports, inventory reports, register reports and much more. Custom reports are also available upon request and include reports needed for tobacco and cigarette sales in certain states. BronzeTag POS also offers the MSA MULTICAT TOB report.</p>
                </div>
                
                </div>
            
            
            
            

    
    

    

            </div>
        </div>
    )
}